export const team = {
  en: {
    title: "Team",
    subtitle: "Manage your internal team members and their access",
    addMember: "Add Member",
    totalMembers: "Total Members",
    admins: "Admins",
    teamMembers: "Team Members",
    active: "Active",
    searchMembers: "Search team members...",
    searchAriaLabel: "Search team members",
    filterByRole: "Filter by role",
    filterByStatus: "Filter by status",
    allRoles: "All Roles",
    admin: "Admin",
    teamMember: "Team Member",
    allStatus: "All Status",
    inactive: "Inactive",
    membersList: "Team members list",
    member: "Member",
    role: "Role",
    status: "Status",
    joined: "Joined",
    actions: "Actions",
    editMember: "Edit Member",
    activate: "Activate",
    deactivate: "Deactivate",
    deleteMember: "Delete Member",
    loadingMembers: "Loading team members...",
    noMembersFound: "No team members found matching your filters.",
    noResultsFor: "No results found for",
    tryAdjusting: "Try adjusting your search or filters",
    addMemberTitle: "Add Team Member",
    addMemberDesc: "Create a new team member account with access to the dashboard.",
    fullName: "Full Name",
    enterFullName: "Enter full name",
    email: "Email",
    enterEmail: "Enter email address",
    password: "Password",
    minChars: "Minimum 6 characters",
    showPassword: "Show password",
    hidePassword: "Hide password",
    roleHelp: "Admins have full access to all features. Team members have limited access.",
    saveMember: "Save Member",
    saving: "Saving...",
    passwordMinLength: "Password must be at least 6 characters",
    allFieldsRequired: "All fields are required",
    emailNoChange: "Email cannot be changed",
    activeStatus: "Active Status",
    activeStatusDesc: "Inactive members cannot log in",
    createdMember: "Created team member",
    failedCreate: "Failed to create team member",
    updatedMember: "Updated team member",
    failedUpdate: "Failed to update team member",
    activated: "Activated",
    deactivated: "Deactivated",
    failedStatusUpdate: "Failed to update status",
    deleteConfirm: "This action cannot be undone.",
    deleteConfirmDesc: "Are you sure you want to delete",
    deleteConfirmSuffix: "? This will permanently remove their account and cannot be undone.",
    deletedMember: "Deleted team member",
    failedDeleteMember: "Failed to delete team member",
    editMemberTitle: "Edit Team Member",
    editMemberDesc: "Update team member information and access level.",
    saveChanges: "Save Changes",
    teamStatistics: "Team statistics",
    // All Users tab
    tabTeam: "Team",
    tabAllUsers: "All Users",
    allUsersSubtitle: "View and manage all registered users across all roles",
    totalUsers: "Total Users",
    customers: "Customers",
    talent: "Talent",
    customer: "Customer",
    searchUsers: "Search users...",
    searchUsersAriaLabel: "Search users",
    usersList: "All users list",
    user: "User",
    company: "Company",
    noUsersFound: "No users found matching your filters.",
    editUserTitle: "Edit User",
    editUserDesc: "Update user information and access level.",
    loadingUsers: "Loading users...",
    userStatistics: "User statistics",
    updatedUser: "Updated user",
    failedUpdateUser: "Failed to update user",
    lastLogin: "Last Login",
    emailVerified: "Verified",
    emailNotVerified: "Not Verified",
    neverLoggedIn: "Never",
  },
  es: {
    title: "Equipo",
    subtitle: "Gestiona los miembros internos del equipo y su acceso",
    addMember: "Agregar Miembro",
    totalMembers: "Total Miembros",
    admins: "Administradores",
    teamMembers: "Miembros del Equipo",
    active: "Activos",
    searchMembers: "Buscar miembros del equipo...",
    searchAriaLabel: "Buscar miembros del equipo",
    filterByRole: "Filtrar por rol",
    filterByStatus: "Filtrar por estado",
    allRoles: "Todos los Roles",
    admin: "Administrador",
    teamMember: "Miembro del Equipo",
    allStatus: "Todos los Estados",
    inactive: "Inactivo",
    membersList: "Lista de miembros del equipo",
    member: "Miembro",
    role: "Rol",
    status: "Estado",
    joined: "Ingresó",
    actions: "Acciones",
    editMember: "Editar Miembro",
    activate: "Activar",
    deactivate: "Desactivar",
    deleteMember: "Eliminar Miembro",
    loadingMembers: "Cargando miembros del equipo...",
    noMembersFound: "No se encontraron miembros del equipo con los filtros aplicados.",
    noResultsFor: "No se encontraron resultados para",
    tryAdjusting: "Intenta ajustar tu búsqueda o filtros",
    addMemberTitle: "Agregar Miembro del Equipo",
    addMemberDesc: "Crear una nueva cuenta de miembro del equipo con acceso al panel.",
    fullName: "Nombre Completo",
    enterFullName: "Ingresa nombre completo",
    email: "Correo Electrónico",
    enterEmail: "Ingresa dirección de correo",
    password: "Contraseña",
    minChars: "Mínimo 6 caracteres",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    roleHelp: "Los administradores tienen acceso completo. Los miembros del equipo tienen acceso limitado.",
    saveMember: "Guardar Miembro",
    saving: "Guardando...",
    passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
    allFieldsRequired: "Todos los campos son requeridos",
    emailNoChange: "El correo no se puede cambiar",
    activeStatus: "Estado Activo",
    activeStatusDesc: "Los miembros inactivos no pueden iniciar sesión",
    createdMember: "Miembro del equipo creado",
    failedCreate: "Error al crear miembro del equipo",
    updatedMember: "Miembro del equipo actualizado",
    failedUpdate: "Error al actualizar miembro del equipo",
    activated: "Activado",
    deactivated: "Desactivado",
    failedStatusUpdate: "Error al actualizar estado",
    deleteConfirm: "Esta acción no se puede deshacer.",
    deleteConfirmDesc: "¿Estás seguro de que deseas eliminar",
    deleteConfirmSuffix: "? Esto eliminará permanentemente su cuenta y no se puede deshacer.",
    deletedMember: "Miembro del equipo eliminado",
    failedDeleteMember: "Error al eliminar miembro del equipo",
    editMemberTitle: "Editar Miembro del Equipo",
    editMemberDesc: "Actualiza la información y nivel de acceso del miembro del equipo.",
    saveChanges: "Guardar Cambios",
    teamStatistics: "Estadísticas del equipo",
    // All Users tab
    tabTeam: "Equipo",
    tabAllUsers: "Todos los Usuarios",
    allUsersSubtitle: "Ver y gestionar todos los usuarios registrados en todos los roles",
    totalUsers: "Total Usuarios",
    customers: "Clientes",
    talent: "Talento",
    customer: "Cliente",
    searchUsers: "Buscar usuarios...",
    searchUsersAriaLabel: "Buscar usuarios",
    usersList: "Lista de todos los usuarios",
    user: "Usuario",
    company: "Empresa",
    noUsersFound: "No se encontraron usuarios con los filtros aplicados.",
    editUserTitle: "Editar Usuario",
    editUserDesc: "Actualiza la información y nivel de acceso del usuario.",
    loadingUsers: "Cargando usuarios...",
    userStatistics: "Estadísticas de usuarios",
    updatedUser: "Usuario actualizado",
    failedUpdateUser: "Error al actualizar usuario",
    lastLogin: "Último Acceso",
    emailVerified: "Verificado",
    emailNotVerified: "No Verificado",
    neverLoggedIn: "Nunca",
  },
};
